var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFinancialManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117 -132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.812 148.031C137.194 148.031 136.688 147.525 136.688 146.906 136.688 146.288 137.194 145.781 137.812 145.781 138.431 145.781 138.938 146.288 138.938 146.906 138.938 147.525 138.431 148.031 137.812 148.031ZM140.625 144.094 140.062 144.094 140.062 141C140.062 140.381 139.556 139.875 138.938 139.875L123.188 139.875C122.878 139.875 122.625 139.622 122.625 139.312 122.625 139.003 122.878 138.75 123.188 138.75L138.938 138.75 138.938 138.188C138.938 137.569 138.431 137.062 137.812 137.062L123.188 137.062C121.95 137.062 120.938 138.075 120.938 139.312L120.938 151.688C120.938 152.925 121.95 153.938 123.188 153.938L138.938 153.938C139.556 153.938 140.062 153.431 140.062 152.812L140.062 149.719 140.625 149.719C140.934 149.719 141.188 149.466 141.188 149.156L141.188 144.656C141.188 144.347 140.934 144.094 140.625 144.094Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinancialManagement);
export default __webpack_public_path__ + "static/media/icon-financial-management.09912f79e39e60cc94c880f5054297fb.svg";
export { ForwardRef as ReactComponent };